module.exports = __webpack_public_path__ + "static/media/36-5.70b2da33.mp3";